module.exports = __webpack_public_path__ + "static/media/welcome.621d6b31632b717731982ee8c08dccf5feb3daf8a15db30f0458708747b94470.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/new-website-popup/welcome.png
// module id = 2340
// module chunks = 204